import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_2 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }

import { getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import store from "@/store";
import { computed } from "vue";
import { statusPage } from "@/utils/constants";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'miscellaneousPage',
  props: {
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["check:answer"],
  setup(__props, { emit: emits }) {

const props = __props;



const statusInPageClone = computed(() => {
  return props.statusInPage;
});

const checkYesNoPii = (value) => {
  if (statusInPageClone.value?.dataError?.[0]?.miscPII)
    delete statusInPageClone.value.dataError[0]["miscPII"];

  const checkedValue = value ? true : false;
  store.commit("SetupWizard/SET_STATE_MISCPII", checkedValue);
};

const checkYesNoPhi = (value) => {
  if (statusInPageClone.value?.dataError?.[0]?.miscPHI)
    delete statusInPageClone.value.dataError[0]["miscPHI"];

  const checkedValue = value ? true : false;
  store.commit("SetupWizard/SET_STATE_MISCPHI", checkedValue);
};

const isMiscPii = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.misc[0]?.values) {
    const isMiscPiiSelected = setupWizard.questions[
      currentOrg.value.id
    ].misc[0].values.some((item) => item.name && item.endDate == null);
    return isMiscPiiSelected ? 1 : 0;
  } else {
    return 0;
  }
});

const isMiscPhi = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.misc[1]?.values) {
    const isMiscPhiSelected = setupWizard.questions[
      currentOrg.value.id
    ].misc[1].values.some((item) => item.name && item.endDate == null);
    return isMiscPhiSelected ? 1 : 0;
  } else {
    return 0;
  }
});


const currentOrg = computed(() => store.state.Org.currentOrg);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WizardQuestion, {
    title: 
      _unref(getComponentUiText)(
        'app-component-wizards-setup-wizard-miscellaneous-page-title-1',
      )
    ,
    description: 
      _unref(getComponentUiText)(
        'app-component-wizards-setup-wizard-miscellaneous-page-sub-title-1',
      )
    
  }, {
    default: _withCtx(() => [
      (
        __props.statusInPage.statusPage === _unref(statusPage).Error &&
        __props.statusInPage.errorMessage
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(WarningIcon, { color: "#F7553C" }),
            _createElementVNode("p", _hoisted_2, _toDisplayString((_unref(getComponentUiText)("app-component-wizards-setup-error-tooltip"),
          false,
          {
            errorMessage: __props.statusInPage.errorMessage
              ? _ctx.ensurePeriod(__props.statusInPage.errorMessage)
              : "",
          })), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(WizardRadioQuestion, {
        title: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-misc-questions-pii-title-1',
        )
      ,
        required: true,
        answer: isMiscPii.value,
        disabled: false,
        "is-api-error": 
        statusInPageClone.value.dataError.length > 0 &&
        statusInPageClone.value.dataError[0]['miscPII'] === true
      ,
        onOnUpdate: checkYesNoPii
      }, null, 8, ["title", "answer", "is-api-error"]),
      _createVNode(WizardRadioQuestion, {
        title: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-modal-misc-questions-phi-title-1',
        )
      ,
        required: true,
        answer: isMiscPhi.value,
        disabled: false,
        "is-api-error": 
        statusInPageClone.value.dataError.length > 0 &&
        statusInPageClone.value.dataError[0]['miscPHI'] === true
      ,
        onOnUpdate: checkYesNoPhi
      }, null, 8, ["title", "answer", "is-api-error"])
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})